/**
 * Navigation interactions for the slide-out nav design.
 * Works with server-rendered HTML from SilverStripe templates.
 * Handles: hamburger toggle, L1/L2 expand, breadcrumb dropdowns, scroll behaviour.
 */

export default function setupNav() {
  var navOpen = false;

  var hamburger = document.getElementById('hamburger');
  var slideNav = document.getElementById('slide-nav');
  var overlay = document.getElementById('nav-overlay');
  var header = document.querySelector('.header');
  var breadcrumbBar = document.getElementById('breadcrumb-bar');

  if (!hamburger || !slideNav || !overlay || !header) return;

  // -----------------------------------
  //  HEADER MODE (from body data attribute)
  // -----------------------------------

  var headerMode = document.body.dataset.headerMode || 'solid';
  if (headerMode === 'transparent') {
    header.classList.add('header--transparent');
  } else if (headerMode === 'hidden') {
    header.classList.add('header--hidden');
  }

  // -----------------------------------
  //  NAV TOGGLE
  // -----------------------------------

  function toggleNav() {
    navOpen = !navOpen;
    slideNav.classList.toggle('open', navOpen);
    overlay.classList.toggle('open', navOpen);
    hamburger.classList.toggle('open', navOpen);

    // On transparent headers, force solid background when nav is open
    if (header.classList.contains('header--transparent')) {
      header.classList.toggle('header--nav-open', navOpen);
    }
  }

  function closeNav() {
    navOpen = false;
    slideNav.classList.remove('open');
    overlay.classList.remove('open');
    hamburger.classList.remove('open');

    if (header.classList.contains('header--transparent')) {
      header.classList.remove('header--nav-open');
    }
  }

  hamburger.addEventListener('click', toggleNav);
  overlay.addEventListener('click', closeNav);

  // -----------------------------------
  //  L1 EXPAND
  // -----------------------------------

  var l1Buttons = document.querySelectorAll('.nav-l1-expand');
  for (var i = 0; i < l1Buttons.length; i++) {
    l1Buttons[i].addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var btn = this;
      var section = btn.dataset.section;
      var group = document.getElementById('l2g-' + section);
      var l1 = document.getElementById('l1-' + section);
      if (!group || !l1) return;

      var isOpen = group.classList.contains('open');

      // Close all L1 groups
      var allL1 = document.querySelectorAll('.nav-l1');
      for (var a = 0; a < allL1.length; a++) allL1[a].classList.remove('active');
      var allL2 = document.querySelectorAll('.nav-l2-group');
      for (var b = 0; b < allL2.length; b++) allL2[b].classList.remove('open');
      var allL3 = document.querySelectorAll('.nav-l3-group');
      for (var c = 0; c < allL3.length; c++) allL3[c].classList.remove('open');
      var allExpand = document.querySelectorAll('.nav-l2-expand, .nav-l1-expand');
      for (var d = 0; d < allExpand.length; d++) {
        allExpand[d].classList.remove('open');
        allExpand[d].textContent = '+';
      }

      if (!isOpen) {
        l1.classList.add('active');
        group.classList.add('open');
        btn.classList.add('open');
        btn.textContent = '\u2212';
      }
    });
  }

  // -----------------------------------
  //  L2 EXPAND
  // -----------------------------------

  var l2Buttons = document.querySelectorAll('.nav-l2-expand');
  for (var j = 0; j < l2Buttons.length; j++) {
    l2Buttons[j].addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var btn = this;
      var groupId = btn.dataset.l3group;
      var group = document.getElementById(groupId);
      if (!group) return;

      var isOpen = group.classList.contains('open');

      var parent = btn.closest('.nav-l2-group');
      if (parent) {
        var parentL3 = parent.querySelectorAll('.nav-l3-group');
        for (var a = 0; a < parentL3.length; a++) parentL3[a].classList.remove('open');
        var parentExpand = parent.querySelectorAll('.nav-l2-expand');
        for (var b = 0; b < parentExpand.length; b++) {
          parentExpand[b].classList.remove('open');
          parentExpand[b].textContent = '+';
        }
      }

      if (!isOpen) {
        group.classList.add('open');
        btn.classList.add('open');
        btn.textContent = '\u2212';
      }
    });
  }

  // -----------------------------------
  //  BREADCRUMB DROPDOWNS
  // -----------------------------------

  function closeAllDropdowns() {
    var triggers = document.querySelectorAll('.bc-current');
    for (var i = 0; i < triggers.length; i++) triggers[i].classList.remove('open');
    var dropdowns = document.querySelectorAll('.bc-dropdown');
    for (var j = 0; j < dropdowns.length; j++) dropdowns[j].classList.remove('open');
  }

  var bcTriggers = document.querySelectorAll('.bc-current');
  for (var k = 0; k < bcTriggers.length; k++) {
    bcTriggers[k].addEventListener('click', function (e) {
      e.stopPropagation();
      var trigger = this;
      var dropdown = trigger.parentElement.querySelector('.bc-dropdown');
      if (!dropdown) return;
      var isOpen = dropdown.classList.contains('open');
      closeAllDropdowns();
      if (!isOpen) {
        trigger.classList.add('open');
        dropdown.classList.add('open');
      }
    });
  }

  document.addEventListener('click', closeAllDropdowns);

  // -----------------------------------
  //  PROFILE DROPDOWN
  // -----------------------------------

  var profileTrigger = document.getElementById('profileTrigger');
  var profileDropdown = document.getElementById('profileDropdown');

  function closeProfileDropdown() {
    if (profileTrigger) profileTrigger.classList.remove('is-open');
    if (profileDropdown) profileDropdown.classList.remove('is-open');
  }

  if (profileTrigger && profileDropdown) {
    profileTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = profileDropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        profileTrigger.classList.add('is-open');
        profileDropdown.classList.add('is-open');
      } else {
        closeProfileDropdown();
      }
    });

    // Close on outside click
    document.addEventListener('click', function () {
      closeProfileDropdown();
    });

    profileDropdown.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // The dropdown's account links are plain hrefs to the server-rendered
    // account pages (/account/dashboard, /account/tickets, ...) — the old
    // dash-panel-switch custom event is gone with the JS-tabbed dashboard.
  }

  // -----------------------------------
  //  MOBILE "MORE" POPOVER (account bottom-nav)
  // -----------------------------------
  var moreTrigger = document.getElementById('mobileMoreTrigger');
  var moreMenu = document.getElementById('mobileMoreMenu');

  function closeMobileMore() {
    if (moreTrigger) moreTrigger.classList.remove('is-open');
    if (moreMenu) moreMenu.classList.remove('is-open');
  }
  if (moreTrigger && moreMenu) {
    moreTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = moreMenu.classList.contains('is-open');
      closeAllDropdowns();
      closeProfileDropdown();
      if (!isOpen) {
        moreTrigger.classList.add('is-open');
        moreMenu.classList.add('is-open');
      } else {
        closeMobileMore();
      }
    });

    // Close on outside click (the menu's own links are plain hrefs).
    document.addEventListener('click', closeMobileMore);
    moreMenu.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  // -----------------------------------
  //  KEYBOARD
  // -----------------------------------

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeNav();
      closeAllDropdowns();
      closeProfileDropdown();
      closeMobileMore();
    }
  });

  // -----------------------------------
  //  SCROLL BEHAVIOUR
  // -----------------------------------

  var lastScrollY = 0;
  var hasBreadcrumb = document.body.dataset.hasBreadcrumb === 'true';
  var condensedH = getComputedStyle(document.documentElement).getPropertyValue('--header-h-condensed').trim();

  // -----------------------------------
  //  OVERSIZED LANDING LOGO CROSS-FADE (homepage)
  //  Big hero logo fades out / header logo fades in over the first
  //  HERO_FADE px of scroll.
  // -----------------------------------
  var heroBrand = document.querySelector('.hero-brand');
  var headerLogo = header.querySelector('.header-logo');
  var stickyHero = document.querySelector('.sticky-hero');

  // Cross-fade happens LATE — as the scrolling body rises to cover the big
  // logo. Range is a fraction of the hero height so it tracks any viewport.
  function updateHeroBrand(currentY) {
    if (!heroBrand || !headerLogo) return;
    var h = stickyHero ? stickyHero.offsetHeight : 600;
    var start = h * 0.55;
    var end = h * 0.82;
    var prog = Math.min(1, Math.max(0, (currentY - start) / (end - start)));
    heroBrand.style.opacity = String(1 - prog);
    headerLogo.style.opacity = String(prog);
    // Don't let the invisible header logo swallow clicks over the hero.
    headerLogo.style.pointerEvents = prog < 0.5 ? 'none' : '';
    // Drive the header bar background fade from the same progress (CSS reads
    // --hero-fade) so the pink bar appears in step with the logo, not on the
    // first pixel of scroll.
    header.style.setProperty('--hero-fade', String(prog));
  }

  updateHeroBrand(window.scrollY);

  window.addEventListener('scroll', function () {
    var currentY = window.scrollY;
    // Matches the CSS header breakpoint: below 1024 the header is in its
    // mobile form, so it hides on scroll-down rather than condensing.
    var isMobile = window.innerWidth <= 1023;

    updateHeroBrand(currentY);

    // Transparent header: solidify as soon as user scrolls
    if (header.classList.contains('header--transparent')) {
      if (currentY > 0) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }

    if (currentY > 80 && currentY > lastScrollY) {
      if (isMobile) {
        // Mobile: hide header entirely
        header.classList.add('mobile-hidden');
        document.body.classList.add('mobile-header-hidden');
        slideNav.style.top = '0';
      } else {
        // Desktop: shrink header, hide breadcrumbs if present
        header.classList.add('condensed');
        document.body.classList.add('header-condensed');
        if (hasBreadcrumb && breadcrumbBar) {
          breadcrumbBar.classList.add('hidden');
          breadcrumbBar.style.top = condensedH;
        }
        slideNav.style.top = condensedH;
      }
    } else {
      // Scrolling up - restore everything
      header.classList.remove('condensed');
      header.classList.remove('mobile-hidden');
      document.body.classList.remove('header-condensed');
      document.body.classList.remove('mobile-header-hidden');
      if (hasBreadcrumb && breadcrumbBar) {
        breadcrumbBar.classList.remove('hidden');
        breadcrumbBar.style.top = '';
      }
      slideNav.style.top = '';
    }

    lastScrollY = currentY;
  });
}
